import React from 'react';
import moment from 'moment';

const display = (value) =>
  value === null || value === undefined || value === '' ? '—' : value;

const displayBool = (value, t) =>
  value === true || value === false
    ? value
      ? t('Yes')
      : t('No')
    : display(value);

const displayDate = (value) =>
  value && moment(value).isValid()
    ? moment(value).format('DD MMMM YYYY')
    : '—';

const fileLink = (url, name) =>
  url ? (
    <a href={url} target='_blank' rel='noreferrer'>
      {name || url}
    </a>
  ) : (
    '—'
  );

export const getCouponViewSections = (t, item) => {
  if (!item?.id) {
    return [];
  }

  return [
    {
      title: t('Info'),
      fields: [
        { text: t('Titolo IT'), value: display(item.title_it) },
        { text: t('Titolo EN'), value: display(item.title_en) },
        { text: t('Titolo FR'), value: display(item.title_fr) },
        { text: t('Richiedente'), value: display(item.author) },
      ],
    },
    {
      title: t('Date'),
      fields: [
        {
          text: t('Inizio pubblicazione'),
          value: displayDate(item.published_at),
        },
        {
          text: t('Data inizio validità'),
          value: displayDate(item.date_from),
        },
        {
          text: t('Data fine validità'),
          value: displayDate(item.date_to),
        },
        {
          text: t('Data scadenza adesione'),
          value: displayDate(item.membership_expiration_date),
        },
      ],
    },
    {
      title: t('Descrizione'),
      fields: [
        { text: t('Descrizione IT'), value: display(item.description_it) },
        { text: t('Descrizione EN'), value: display(item.description_en) },
        { text: t('Descrizione FR'), value: display(item.description_fr) },
      ],
    },
    {
      title: t('Shop'),
      fields: [{ text: t('Insegna'), value: display(item.company) }],
    },
    {
      title: t('Files'),
      fields: [
        {
          text: t('Immagine'),
          value: fileLink(item.allData?.image, item.allData?.image_name),
        },
      ],
    },
    {
      title: t('Opzioni'),
      fields: [
        {
          text: t('Fino esaurimento scorte'),
          value: displayBool(item.until_last, t),
        },
        {
          text: t('Solo per dipendenti'),
          value: displayBool(item.staff_only, t),
        },
        { text: t('Stato'), value: display(item.published) },
        { text: t('Retail approvato'), value: display(item.retail_approved) },
        {
          text: t('Marketing approvato'),
          value: display(item.marketing_approved),
        },
      ],
    },
    {
      title: t('CANALI DI COMUNICAZIONE'),
      fields: [
        {
          text: 'Uso Archivio (printers)',
          value: displayBool(item.is_archive, t),
        },
        {
          text: 'NEWSLETTER (newsletter)',
          value: displayBool(item.is_newsletter, t),
        },
        { text: 'RADIO VILLAGE (radio)', value: displayBool(item.is_radio, t) },
        { text: 'SOCIAL (social)', value: displayBool(item.is_social, t) },
        { text: 'WEB', value: displayBool(item.is_web, t) },
      ],
    },
  ];
};
